import type { DomesticInfoRequestBody } from '@weberus/shared-types';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { isUndefined, omitBy, pick } from 'lodash-es';
import { fetchLocalAccommodationInfo } from '@/app/(pages)/local/api';
import { QueryKeys } from './query-keys';

export const searchQueryKeys = createQueryKeys(QueryKeys.search, {
  /** 국내숙소 정보 조회 */
  getLocalAccommodationInfo: (args: DomesticInfoRequestBody) => {
    // 기존 sunny-web에서 사용되는 API 사용을 위해 SearchDomesticInfoRequest 필드 중 header 조회를 위한 필드만 추출
    const filteredArgs = omitBy(pick(args, ['pageName', 'keyword', 'region']), isUndefined) as DomesticInfoRequestBody;

    return {
      queryKey: [filteredArgs],
      queryFn: () => fetchLocalAccommodationInfo(filteredArgs),
    };
  },
});
